export const SbscomRoutes = [
  {
    path: '/deals',
    name: 'Deals',
    component: () =>
      import(
        /* webpackChunkName: "lp-urlaubsguru" */ /* webpackPreload: true */ '../views/Landingpages/Sbscom/Deals.vue'
      ),
    meta: {
      breadcrumb: 'Deals',
    },
  },
]
